import type { ModePerformance } from "@mk/shared";
import { formatNumber, formatPercent } from "../../lib/edition.ts";

export function emptyPerformance(): ModePerformance {
  return { played: 0, found: 0, missed: 0, averageAttempts: null, guessDistribution: {} };
}

export function performanceFromDistribution(
  played: number,
  found: number,
  guessDistribution: Readonly<Record<string, number>>,
): ModePerformance {
  const totalAttempts = Object.entries(guessDistribution).reduce(
    (sum, [attempt, count]) => sum + Number(attempt) * count,
    0,
  );
  return {
    played,
    found,
    missed: Math.max(0, played - found),
    averageAttempts: found > 0 ? totalAttempts / found : null,
    guessDistribution: { ...guessDistribution },
  };
}

export function mergePerformance(...items: readonly ModePerformance[]): ModePerformance {
  const merged = emptyPerformance();
  let totalAttempts = 0;
  for (const item of items) {
    merged.played += item.played;
    merged.found += item.found;
    merged.missed += item.missed;
    if (item.averageAttempts !== null) totalAttempts += item.averageAttempts * item.found;
    for (const [attempt, count] of Object.entries(item.guessDistribution)) {
      merged.guessDistribution[attempt] = (merged.guessDistribution[attempt] ?? 0) + count;
    }
  }
  merged.averageAttempts = merged.found > 0 ? totalAttempts / merged.found : null;
  return merged;
}

export function rate(part: number, total: number): string {
  return total === 0 ? "—" : formatPercent(part / total);
}

export function averageAttemptsLabel(value: number | null): string {
  return value === null
    ? "—"
    : formatNumber(value, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}
